import React from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import * as types from '../constants/Types'
import { getTranslation } from '../actions/dataActions'
import * as resource from '../constants/Resources'

const Reservation = (props) => {
  const {
    reservation,
    getTranslation
  } = props;

  const receipt = reservation.receipt;

  return (
    <div>
      {receipt ?
        receipt.receiptLines && receipt.receiptLines.filter(line => line.lineType === types.ARTICLE_LINE).map((line, index) =>
          <div className="receiptLine" key={index}>
            <div className="quantity">{line.quantity} x</div>
            <div className="description">{line.description}</div>
            <div className="price">&euro;{line.netAmount.toFixed(2)}</div>
          </div>
        ) : getTranslation(resource.NO_TICKETS_FOUND)
      }
    </div>
  )
}

Reservation.propTypes = {
  reservation: PropTypes.object.isRequired
}

export default connect(null, { getTranslation })(Reservation)



// WEBPACK FOOTER //
// src/components/Reservation.jsx